import { graphqlApi } from "../../graphql/api";
import { initializeColorList } from "../../graphql/slices/dashboardCalendar";
import { setEnrollmentNames, setEnrollments, setEnrollmentsAssignmentsQueue } from "../../graphql/slices/enrollments";
import { getEnrollments } from "../enums";
import { chips } from "./shared";
const CONSTANTS = {
  get: getEnrollments,
};

const get = `
    ${CONSTANTS.get} {
      ${chips}
      data {
        name
        courseId
        term
        termCode
        termName
        includeAssignments
        includeFiles
        includeGrades
        includeUsers
        itemHash
      }

    }
`;

const transformResponse =  (response, { dispatch, getState }) => {
  const { data  = []} = response?.data?.[getEnrollments] ?? {}
  const courseNames = {}
  let queue = []

  data.forEach(({ courseId, name, ...rest }) => {
    const state = getState()
    const cachedCourses = state?.assignments?.courses
    const existingCourseAssignments = cachedCourses?.[courseId]
    if(courseId && !existingCourseAssignments?.length) {
      queue.push(courseId)
      dispatch(graphqlApi.endpoints.getAssignments.initiate({
        courseId
      }))
    }
    if(courseId) {
      courseNames[courseId] = name ?? ""
    }
  })
  dispatch(setEnrollments({
    enrollments: data
  }))
  dispatch(setEnrollmentNames({
    courses: courseNames
  }))
  dispatch(setEnrollmentsAssignmentsQueue({
    queue
  }))
  if(!queue.length) {
    dispatch(initializeColorList())
  }
  return response
}

const source = {
  CONSTANTS,
  QUERIES: {
    get,
  },
  transformResponse
};


export default source;
